<template>
  <section>
    <v-sheet
      color="white"
      elevation="5"
      outlined
      rounded
      shaped
      class="boxauthoriation"
    >
      <v-row>
        <v-col class="text-center">
          <router-link to="/">
            <img src="@/assets/logo.png" />
          </router-link>
        </v-col>
        <v-col md="12">
          <h3 class="text-center titleform">Forget Password</h3>
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            class="form-section"
          >
            <v-row>
              <v-col md="12" cols="12">
                <v-text-field
                  v-model="email"
                  label="Email Address"
                  :rules="emailRules"
                  outlined
                  @keyup.enter.stop="validate"
                ></v-text-field>
              </v-col>
    
              <v-col cols="12" class="submitbtn">
                <v-btn
                  :disabled="!valid"
                  class="submitbutton btn-dark"
                  @click="validate"
                  v-if="!allLoadingAuth"
                >
                  Forget
                </v-btn>
                <v-progress-circular
                  v-if="allLoadingAuth"
                  indeterminate
                ></v-progress-circular>
              </v-col>
            </v-row>
          </v-form>
          <template v-if="allLogin.data">
            <v-snackbar v-model="snackbar">
              {{ allLogin.data.message }}

              <template v-slot:action="{ attrs }">
                <v-btn
                  color="white"
                  text
                  v-bind="attrs"
                  @click="snackbar = false"
                >
                  Close
                </v-btn>
              </template>
            </v-snackbar>
          </template>
        </v-col>
      </v-row>
    </v-sheet>
  </section>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "Forget",
  data() {
    return {
      allUserloading: false,
      valid: true,
      email: "",
      password: "",
      showpassword: false,
      emailRules: [(v) => !!v || "Email is required"],
      rules: {
        required: (value) => !!value || "Password is required.",
        min: (v) => v.length >= 8 || "Min 8 characters",
      },
      snackbar: false,
    };
  },
  methods: {
    ...mapActions(["forget"]),
    validate() {
      if (this.$refs.form.validate()) {
        let userData = {
          email: this.email,
        };
        this.forget(userData);
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    logout() {
      this.$store.dispatch("logoutUser");
    },
  },
  computed: {
    ...mapGetters(["allLoadingAuth", "allLogin"]),
  },
  created() {
    if (localStorage.getItem("token") != undefined) {
      this.$router.push("/").catch((err) => {
        console.error(err);
      });
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";
.boxauthoriation {
  padding: 30px;
  width: 450px;
  border-radius: 10px !important;
}
.registerlink {
  margin-top: 15px;
  a {
    margin-left: 5px;
    color: $tagcolor;
  }
}

.submitbtn {
  text-align: center;
}
img {
  width: 100px;
}
.form-section {
  .col-md-6,
  .col-md-12 {
    padding: 0 20px !important;
  }
}
.titleform {
  margin-bottom: 20px;
}
.registerlink {
  margin-top: 20px;
  font-size: 14px;
}
.btn-dark {
  background: $tagcolor !important;
  color: $white !important;
  width: 200px;
  height: 50px !important;
}
</style>
